<template>
  <b-row class="docs-container">
    <b-col class="docs-sidebar" cols="2">
      <nav>
        <section
          v-for="section in sections"
          :key="section.title"
          class="docs-section"
        >
          <h4>{{ section.title }}</h4>
          <div
            v-for="link in section.helpSectionLinks"
            :key="link.id"
            class="docs-link"
          >
            <router-link :to="$route.path.includes('ministry') ? `/ministry/docs/${link.slug}` : `/docs/${link.slug}`">
              {{ link.slug }}

            </router-link>
          </div>
        </section>
      </nav>
    </b-col>
    <b-col>
      <b-container>
        <b-card style="min-height: 70vh">
          <transition name="fade" mode="out-in">
            <router-view :key="$route.path" />
          </transition>
        </b-card>
      </b-container>
    </b-col>
  </b-row>
</template>

<script>
import { BContainer, BRow, BCol, BCard } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
  },
  data() {
    return {
      // sections: [
      //   {
      //     title: "عنوان 1",
      //     links: [],
      //   },
      //   {
      //     title: "عنوان 2",
      //     links: [],
      //   },
      // ],
    };
  },
  computed: {
    ...mapGetters("Docs", ["loading", "sections"]),
  },
  methods: {
    ...mapActions("Docs", ["getSections"]),
  },
  created() {
    this.getSections();
  },
};
</script>

<style lang="scss">
.docs-sidebar {
  padding: 4rem 2rem;
  height: 73vh;
  overflow: auto;
  border-inline-end: 1px solid #dddddd;
  .docs-link {
    width: 100%;
    margin-bottom: 3px;
  }
  .docs-section {
    h5 {
      font-weight: bold;
      margin-bottom: 1rem;
    }
  }
  .docs-section + .docs-section {
    margin-top: 2rem;
  }
  nav {
    display: flex;
    flex-direction: column;
    a {
      width: fit-content;
      font-size: 16px;
    }
  }
}
</style>
